import moment from 'moment'
import _ from 'lodash'
export default class Utility {
    public static currency(value, currency = '', decimals = 0) {
        const digitsRE = /(\d{3})(?=\d)/g
        value = parseFloat(value)
        if (!isFinite(value) || (!value && value !== 0)) return '0'
        currency = currency == 'CNY' ? '¥' : currency == null ? '' : currency
        decimals = decimals != null ? decimals : 0
        var stringified = Math.abs(value).toFixed(decimals)
        var _int = decimals
            ? stringified.slice(0, -1 - decimals)
            : stringified
        var i = _int.length % 3
        var head = i > 0
            ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
            : ''
        var _float = decimals
            ? stringified.slice(-1 - decimals)
            : ''
        var sign = value < 0 ? '-' : ''
        const Xcurrency = currency ? (currency !== '%' ? currency + ' ' : ' ' + currency) : ''
        return currency !== '%' ? Xcurrency + sign + head +
            _int.slice(i).replace(digitsRE, '$1,') +
            _float : sign + head +
            _int.slice(i).replace(digitsRE, '$1,') +
            _float + Xcurrency
    }

    public static randomString(length: number = 10) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return result;
    }

    public static isNullOrWhitespace(value: any) {
        if (value === null || value === undefined) { return true; };
        if (value.toString().trim() === '') { return true; };
        return false;
    }

    public static print_export_receipt_order(item, packages, print = false) {
        let html_packages = ''
        let note_tag = `<td class='body-text m-text width-note' rowspan='${packages.length}'>${item.Note || ''}</td>`
        for (let i = 0; i < packages.length; i++) {
            const p = packages[i];
            html_packages = html_packages + `<tr>
                              <td class='body-text m-text'>${i + 1}</td>
                              <td class='body-text'>${p.TransactionCode}</td>
                              <td class='body-text'>${(p.OrderType == 1 ? 'MD' : 'KG') + p.OrderID}</td>
                              <td class='body-text m-text'>${p.KennelName || ''}</td>
                              <td class='body-text m-text'></td>
                              <td class='body-text r-text'>1</td>
                              <td class='body-text r-text'>${Utility.currency(p.Weight, '', 2)}</td>
                              <td class='body-text r-text'>${Utility.currency(p.Volume, '', 2)}</td>
                              ${i == 0 ? note_tag : ''}
                            </tr>`
        }

        const print_content = `<html>
        <head>
            <title></title>
            <style>
                .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 11px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 11px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 11px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 20mm 8mm 8mm 20mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;} .width-note {width: 160px;}
            </style>
        </head>
        
        <body style='width:210mm;font-family: Roboto,sans-serif;'>
            <div class='layout wrap'>
                <table>
                    <tr>
                      <td class='no-boder sub-title m-text'><image style="width: 80px" src='/assets/images/logo/square_logo.png'/></td>
                      <td class='no-boder sub-title m-text'>CÔNG TY TNHH UNISHIP LOGISTICS</td>
                    </tr>	
                    <tr>
                      <td class='no-boder sub-title m-text'>www.uniship.vn - hotline: 0825.14.14.14</td>
                      <td class='no-boder body-text m-text'><i>Ngày ${moment(item.exportDate).date()} tháng ${moment(item.exportDate).month() + 1} năm ${moment(item.exportDate).year()}</i></td>
                    </tr>	
                    <tr>        
                      <td class='no-boder title m-text' colspan='4'><b>PHIẾU XUẤT KHO</b></td>
                    </tr>
                    <tr>        
                      <td class='no-boder body-text' colspan='4'><b>Số phiếu:</b> ${item.id}/UNS${moment().year()}/${item.uId}</td>
                    </tr>
                    <tr>        
                      <td class='no-boder body-text' colspan='2'><b>Người nhận hàng:</b> ${item.userName} (${item.phone || ''}) - ${item.address || ''}</td>
                    </tr>
                  </table>
                  <table>
                    <tr>
                        <td class='sub-title m-text' rowspan='2'>STT</td>            
                        <td class='sub-title m-text' rowspan='2'>Tên, mã hàng hóa</td>            
                        <td class='sub-title m-text' rowspan='2'>Mã đơn hàng</td>
                        <td class='sub-title m-text' rowspan='2'>Lưu kho</td>
                        <td class='sub-title m-text' rowspan='2'>ĐVT</td>            
                        <td class='sub-title m-text quantity' rowspan='2'>Số lượng</td>            
                        <td class='sub-title m-text' colspan='2'>Khối lượng</td>            
                        <td class='sub-title m-text width-note' rowspan='2'>Ghi chú</td>
                    </tr>
                    <tr>                
                        <td class='sub-title r-text width-volumn'>KG</td>
                        <td class='sub-title r-text width-volumn'>Kích thước</td>
                    </tr>
                    ${html_packages}
                    <tr>
                      <td class='sub-title m-text' colspan='4'>Tổng số</td>
                      <td class='sub-title m-text'></td>
                      <td class='sub-title r-text'>${packages.length}</td>
                      <td class='sub-title r-text'>${Utility.currency(_.sumBy(packages, 'Weight'), '', 2)}</td>
                      <td class='sub-title r-text'>${Utility.currency(_.sumBy(packages, 'Volume'), '', 2)}</td>
                      <td class='sub-title m-text'></td>
                    </tr> 
                    <tr>
                        <td class='no-boder body-text' colspan='9'><i>Chủ hàng hoặc người nhận hộ (Shiper, Nhà xe, .v.v.) vui lòng kiểm tra số lượng và tình trạng bên ngoài các kiện hàng trước khi ký nhận.</i></td>
                    </tr>
                    <tr>
                        <td class='no-boder body-text' colspan='9'><i>Quý khách nhận hàng, vui lòng quay chụp ảnh/ Video thời điểm nhận hàng, để khi cần có thể đối chiếu với UNISHIP về tình trạng kiện hàng và số lượng hàng nhận.</i></td>
                    </tr> 
                    <tr>
                        <td class='no-boder body-text' colspan='9'><i>UNISHIP sẽ không giải quyết khiếu nại bao gồm: Thiếu, mất, hỏng hóc, móp méo kiện hàng sau 48h kể từ khi xuất kho. Xin cảm ơn!</i></td>
                    </tr> 
                    <tr>
                        <td class='no-boder sub-title m-text' colspan='3'>Người nhận hàng<br/><i>(Ký, ghi rõ họ tên)</i></td>
                        <td class='no-boder sub-title m-text' colspan='3'>Người vận chuyển<br/><i>(Ký, ghi rõ họ tên)</i></td>
                        <td class='no-boder sub-title m-text' colspan='3'>Người lập phiếu<br/><i>(Ký, ghi rõ họ tên)</i></td>
                    </tr> 
                    </table>
                  </div>
              </body>
        </html>`;
        if (print) {
            const iframe = document.getElementById('print_frame') as HTMLIFrameElement;
            if (iframe && iframe.contentWindow) {
                const doc = iframe.contentWindow.document;
                doc.open();
                doc.write(print_content);
                doc.close();
                setTimeout(function () { window.frames["print_frame"].window.print(); }, 1000);
            }
        }
        else {
            var mywindow = window.open("", "PRINT");
            if (mywindow) {
                mywindow.document.write(print_content);
                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/
                // mywindow.close();
            }
            return true;
        }
    }
    public static print_transaction_v2(item) {
        let frame_printing = '';
        let barcode_width = item.TransactionCode && item.TransactionCode.length <= 17 ? 1.86 : 1.48;
        let invert_order = item.PriceType == 2;
        let sender = `<tr>
                        <td class='body-text m-text'>FROM</td>
                        <td class='body-text' colspan='4'>Name: Guangzhou Ronghe Purchasing Agent Co. LTD
                            <br/>Mobile: +8615677000469
                            <br/>Add: Building 2, No. 181, Wanggang Xiling Road, Jiahe Street, Baiyun District, Guangzhou City, Guangdong Province, China</td>
                      </tr>`;
        if (invert_order) {
            sender = `<tr>
                      <td class='body-text m-text'>FROM</td>
                      <td class='body-text' colspan='4'>Name: ${item.ChinaStoreName}
                          <br/>Mobile: ${item.ChinaStorePhone}
                          <br/>Add: ${item.ChinaStoreAddress}</td>
                    </tr>`;
        }
        let receiver = `<tr>
                          <td class='body-text m-text' rowspan='3'>TO</td>
                          <td class='body-text'>Name</td>
                          <td class='body-text' colspan='3'>${item.FullName}</td>
                        </tr>
                        <tr>
                          <td class='body-text'>Mobile</td>
                          <td class='body-text' colspan='3'>${item.FakePhone}</td>
                        </tr>
                        <tr>
                          <td class='body-text'>Add</td>
                          <td class='body-text' colspan='3'>${item.Address}</td>
                        </tr>`;
        if (invert_order) {
            receiver = `<tr>
                        <td class='body-text m-text'>TO</td>
                        <td class='body-text' colspan='4'>Name: ${item.ReceiveAddress}</td>
                      </tr>`
        }
        let service = '';
        if (!invert_order) {
            service = `<tr>
                        <td class='body-text m-text' colspan='2'>Service</td>
                        <td class='body-text' colspan='3'>E</td>
                    </tr>`;
        }
        frame_printing = frame_printing + (`<html>
        <head>
            <title></title>
            <script src="https://cdn.jsdelivr.net/jsbarcode/3.5.1/JsBarcode.all.min.js"></script>
            <style>
                .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 9px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 9px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 9px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #dddddd; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; } @media print { @page { size: auto; margin: 2mm 2mm 2mm 2mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } }
            </style>
        </head>
        
        <body style='width:100mm'>
            <div class='layout wrap'>
                <table>
                    <tr>
                        <td class='m-text' colspan='4'><svg id="code128"></svg></td>
                        <td class='sub-title m-text'>Id Custom: ${item.UID}<br/>Order Id: ${(item.PackageType == 1 ? (invert_order ? item.DepositCode : 'KG') : 'MD') + item.OrderID}</td>
                    </tr>
                    ${sender}
                    ${receiver}
                    <tr>
                        <td class='sub-title' colspan='5'>Shipment Detail</td>
                    </tr>
                    ${service}
                    <tr>
                        <td class='body-text m-text' colspan='2'>Product Quantity<br/>(Số lượng SP)</td>
                        <td class='body-text m-text'>Actual weight<br/>(Trọng lượng thực tế kg)</td>
                        <td class='body-text m-text'>Volume<br/>(Thể tich m3)</td>
                        <td class='body-text m-text'>Chargeable weight<br/>(Khối lượng tính phí)</td>
                    </tr>
                    <tr>
                        <td class='sub-title m-text' colspan='2'>${Utility.currency(item.ProductNumber)}</td>
                        <td class='sub-title m-text'>${Utility.currency(item.Weight, '', 1)}</td>
                        <td class='sub-title m-text'>${Utility.currency(item.Volume, '', 1)}</td>
                        <td class='sub-title m-text'>${Utility.currency(item.ChargeableWeight, '', 1)}</td>
                    </tr>
                    <tr>
                        <td class='sub-title' colspan='5'>Product Detail</td>
                    </tr>
                    <tr>
                        <td class='body-text m-text' colspan='4'>Name</td>
                        <td class='body-text m-text'>Product Detail</td>
                    </tr>
                    <tr>
                        <td class='body-text m-text' colspan='4'>${item.ProductName ? item.ProductName : ''}</td>
                        <td class='body-text m-text'></td>
                    </tr>
                    <tr>
                        <td class='body-text m-text' colspan='2'>Payment COD: <b>${!invert_order ? Utility.currency(item.ProductAmountVND) + 'VNĐ' : Utility.currency(item.ProductAmount, '¥', 2)}</b></td>
                        <td class='body-text m-text' colspan='3'>Receiver's signature<br/>(Confirm intact goods)</td>
                    </tr>
                </table>
            </div>
            <script>
              JsBarcode("#code128", "${invert_order ? item.VbiCode : item.TransactionCode}", {format: "code128", fontSize: 16, height: 66, width: ${barcode_width}, textMargin: 2});
            </script>
        </body>
        </html>`);
        const element: HTMLIFrameElement = document.getElementById('print_frame') as HTMLIFrameElement;
        const iframe = element.contentWindow;
        if (iframe !== null) {
            var doc = iframe.document;
            doc.open();
            doc.write(frame_printing);
            doc.close();
            setTimeout(function () { window.frames["print_frame"].window.print(); }, 1000);
        }
    }
    public static proxyImage(imageUrl) {
        if (!imageUrl) {
            return ''
        };
        
        // Nếu ảnh đã là từ domain local thì không cần proxy
        if (imageUrl.startsWith('/') || imageUrl.includes(window.location.hostname) || imageUrl.includes('firebase')) {
            return imageUrl;
        }
        
        // return `https://dash.phanmemdathangoee.com/oee-images/${imageUrl.replace(/https?:\/\//, '')}`;
        return `https://image-proxy.mamdtech.com/oee-images/${imageUrl.replace(/https?:\/\//, '')}`;
    }
}